// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"231700f6866b3b44","2543":"1b1ce9ef96210c54","3481":"79e0b7b84b4e00f7","6972":"e6a6d0634400a066"}[chunkId] + ".css";
};